import { Box, Typography } from "@mui/material";
import { Circle } from "lucide-react";
import { useState } from "react";
import { ruleGraphCanvasControlSx } from "./ruleGraphCanvasControlSx";

export const RuleGraphBackToStart = ({
  onClick,
  disabled = false,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const showsHoverState = isHovered && !disabled;

  return (
    <Box
      aria-label="Back to start"
      component="button"
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={(theme) => ({
        ...ruleGraphCanvasControlSx(disabled)(theme),
        gap: 1.5,
        height: 30,
        px: 3,
        py: 1.5,
        width: 113,
        "&:hover:not(:disabled)": {
          borderColor: theme.igBackgroundColors.interactive.dark.disabled,
        },
        "&:active:not(:disabled)": {
          backgroundColor: theme.igBackgroundColors.interactive.neutral.active,
        },
      })}
      type="button"
    >
      <Box
        aria-hidden="true"
        component={Circle}
        data-testid="rule-graph-back-to-start-icon"
        size={10}
        strokeWidth={1.5}
        sx={(theme) => ({
          color: showsHoverState
            ? theme.palette.text.primary
            : theme.palette.text.tertiary,
        })}
      />
      <Typography
        component="span"
        sx={(theme) => ({
          color: showsHoverState
            ? theme.palette.text.primary
            : theme.palette.text.tertiary,
          fontSize: 12,
          lineHeight: 1.5,
          whiteSpace: "nowrap",
        })}
      >
        Back to start
      </Typography>
    </Box>
  );
};
